import { Component, Input } from '@angular/core';

import { MijnNavigatieService } from '@ap/mijn-navigatie';

import { MijnTemplateNavigation } from '../../mijn-template.navigation';

import { Breadcrumb } from './breadcrumb.model';

/**
 * @module BreadcrumbModule
 * @ngdoc component
 * @name BreadcrumbComponent
 */
@Component({
    selector: 'mijn-overzicht-template-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    standalone: false
})
export class BreadcrumbComponent {
    @Input()
    public breadcrumb: Breadcrumb;

    public constructor(
        private readonly mijnNavigatieService: MijnNavigatieService,
        private readonly mijnTemplateNavigation: MijnTemplateNavigation
    ) {}

    public navigateBack(): void {
        if (this.breadcrumb.internal) {
            this.mijnTemplateNavigation.internal(this.breadcrumb.path);
        } else if (this.breadcrumb.dynamic) {
            this.mijnTemplateNavigation.dynamicBack(false);
        } else {
            this.mijnTemplateNavigation.external(this.breadcrumb.path);
        }
    }
}
